import { render, staticRenderFns } from "./ReportParamsTable.vue?vue&type=template&id=c2f690aa&"
import script from "./ReportParamsTable.vue?vue&type=script&lang=js&"
export * from "./ReportParamsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports